/**
 * @file App.js
 * Main entry point for the application, setting up routing and rendering core components.
 */

import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Login from "./Pages/Login";
import AdminPanel from "./Pages/AdminPanel";
import Home from "./Pages/Home";
import Navbar from "./Components/Navbar";
import Register from "./Pages/Register";
import Overview from "./Pages/Overview";
import Practice from "./Pages/Practice";
import Mock from "./Pages/Mock";
import Question from "./Pages/Question";
import Mockquestion from "./Pages/Mockquestion";
import Hazard from "./Pages/Hazard";
import HazardPerception from "./Pages/Hazardperception";
import Casestudy from "./Pages/Casestudy";
import CaseQuestions from "./Pages/CaseQuestions";
import UserHazardList from "./Pages/UserHazadList";
import UserHazardDetails from "./Pages/UserHazardDetails";
import Pricing from "./Pages/Pricing";
import Forgot from "./Pages/Forgot";
import UserMocks from "./Pages/UserMocks";
import MockDetails from "./Pages/MockDetails";
import Footer from "./Components/Footer";
import About from "./Pages/About";
import Deleteaccount from "./Pages/Deleteaccount";
import Privacy from "./Pages/Privacy";
import Admin from "./Pages/Admin";
import PracticeResult from "./Pages/PracticeResult";
import ContactUs from "./Pages/ContactUs";
/* import { useLocales } from "react-admin"; */

/**
 * Main content component for the application.
 * Manages application-wide state, including user, language, and tree selection, with i18n setup for language management.
 *
 * @component
 * @returns {JSX.Element} Renders the main content of the app.
 */
function AppContent() {
  /* useEffect(() => {
    const lang = localStorage.getItem("lang") || "en";
    document.body.classList.toggle("bangla", lang === "bn");
  }, []); */
  const location = useLocation();
  return (
    <div className="App">
      {!location.pathname.startsWith("/admin") && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/practice" element={<Practice />} />
        <Route path="/mocktest" element={<Mock />} />
        <Route path="/admin_panel" element={<AdminPanel />} />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="/practice-questions" element={<Question />} />
        <Route path="/mockquestion" element={<Mockquestion />} />
        <Route path="/hazard-list" element={<Hazard />} />
        <Route path="/hazard/:id" element={<HazardPerception />} />
        <Route path="/casestudy" element={<Casestudy />} />
        <Route path="/case/:id" element={<CaseQuestions />} />
        <Route path="/review-hazards" element={<UserHazardList />} />
        <Route path="user-mocks" element={<UserMocks />} />
        <Route path="/mock/:mockId" element={<MockDetails />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/forgot-password" element={<Forgot />} />
        <Route path="/about" element={<About />} />
        <Route path="/delete-account" element={<Deleteaccount />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/practice-result" element={<PracticeResult />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route
          path="/review-hazards/:hazardId"
          element={<UserHazardDetails />}
        />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </div>
  );
}
/**
 * Root component of the app, wraps `AppContent` with `BrowserRouter` for routing functionality.
 *
 * @component
 * @returns {JSX.Element} The root component of the application.
 */
function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
